import React, { Component } from "react";
import ChipInput from "material-ui-chip-input";
import { connect } from "react-redux";
import clsx from "clsx";

class CustomChipInput extends Component {
  render() {
    const {
      classes,
      value,
      onAdd,
      onDelete,
      disabled,
      playlistEditor,
      title,
      name,
      ...other
    } = this.props;

    return (
      <>
        <label className={classes.globalCreateLabel} htmlFor={title}>
          {title}
        </label>
        <span>:</span>
        <div className="flexItem">
          <ChipInput
            name={name}
            className={clsx(classes.addChipset, classes.playlistChips)}
            disabled={disabled}
            variant="outlined"
            value={value}
            InputProps={{
              inputProps: {
                max: 5,
                min: 0,
                "aria-label": "Add playlist tags",
              },
            }}
            onAdd={onAdd}
            onDelete={onDelete}
            {...other}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  //data: state.bulkEdit,
});

export default connect(mapStateToProps)(CustomChipInput);
